
import Bed from '@/assets/icons/fontawesome/duotone/bed.svg?inline'
import Gift from '@/assets/icons/fontawesome/duotone/gift.svg?inline'
import Wifi from '@/assets/icons/fontawesome/light/wifi.svg?inline'
import Images from '@/assets/icons/fontawesome/light/images.svg?inline'
import BedAlt from '@/assets/icons/fontawesome/light/bed-alt.svg?inline'
import Coffee from '@/assets/icons/fontawesome/duotone/coffee.svg?inline'
import ThumbsUp from '@/assets/icons/fontawesome/regular/thumbs-up.svg?inline'
import SmokingBan from '@/assets/icons/fontawesome/light/smoking-ban.svg?inline'
import UserFriends from '@/assets/icons/fontawesome/duotone/user-friends.svg?inline'
import UtensilsAlt from '@/assets/icons/fontawesome/duotone/utensils-alt.svg?inline'
import ExternalLink from '@/assets/icons/fontawesome/light/external-link.svg?inline'
import ExpandArrows from '@/assets/icons/fontawesome/light/expand-arrows.svg?inline'

export default {
  components: {
    Bed,
    Gift,
    Wifi,
    Images,
    BedAlt,
    Coffee,
    ThumbsUp,
    SmokingBan,
    UserFriends,
    UtensilsAlt,
    ExternalLink,
    ExpandArrows,
  },
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    types: {
      type: Array,
      required: true,
    },
    sending: {
      type: Boolean,
      required: false,
    },
    cartresultcode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      room: null,
      modalOpen: false,
    }
  },
  computed: {
    hotelCity() {
      if (this.hotel.aggregator === 'innstant') {
        return this.hotel.city.slug
      }

      return null
    },
    hotelCountry() {
      return this.hotel.country.slug
    },
  },
  methods: {
    openRoom(room) {
      this.room = room
      this.modalOpen = true
    },
    openRemarks(code) {
      this.$emit('open-remarks', code)
    },
    openQuote(result) {
      this.$emit('open-quote', result)
    },
    openCart(result) {
      this.$emit('open-cart', result)
    },
  },
}
